/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * ユーザー
 * @export
 * @interface VerifyUserUser
 */
export interface VerifyUserUser {
    /**
     * ログインユーザーのタイプ
     * @type {string}
     * @memberof VerifyUserUser
     */
    type: VerifyUserUserTypeEnum;
    /**
     * ログインユーザー向け管理画面へのパス
     * @type {string}
     * @memberof VerifyUserUser
     */
    myPagePath: string;
}

/**
* @export
* @enum {string}
*/
export enum VerifyUserUserTypeEnum {
    Company = 'company',
    Media = 'media',
    Social = 'social'
}

export function VerifyUserUserFromJSON(json: any): VerifyUserUser {
    return VerifyUserUserFromJSONTyped(json, false);
}

export function VerifyUserUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyUserUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'myPagePath': json['my_page_path'],
    };
}

export function VerifyUserUserToJSON(value?: VerifyUserUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'my_page_path': value.myPagePath,
    };
}

